const t = "_contentSection_dn20f_1", n = "_title_dn20f_4", e = "_text_dn20f_8", o = {
  contentSection: t,
  title: n,
  text: e
};
export {
  t as contentSection,
  o as default,
  e as text,
  n as title
};
